/**
 * Handles notifications for when stream-admin is used as a MicroApps.
 *
 * @class NotificationHandler
 *
 * @property {Object} handler - Stores the notification methods.
 *
 * @method init
 * Initializes the notification handler and sets up the messenger.
 *
 * @method success
 * Displays a success notification.
 *
 * @method error
 * Displays an error notification.
 *
 * @method info
 * Displays an informational notification.
 *
 * @method warn
 * Displays a warning notification.
 *
 * @param {string} type - Type of notification (`'error'`, `'success'`, `'info'`, `'warning'`).
 * @param {string} message - Message to display in the notification.
 * @param {Object} [opts={}] - Optional settings for the notification.
 * @param {string} [opts.id] - Optional ID for the notification to ensure the notification is only rendered once.
 */

import { isMicroapp, generateMicroappMessenger } from '@utils/general';

class NotificationHandler {
  constructor() {
    this.handler = {
      sendNotification: () => { },
    };
  }

  async init(messengerInstance) {
    if (isMicroapp()) {
      this.handler = messengerInstance || await generateMicroappMessenger();
      this.isMicroapp = true;
    }
  };

  success(message, opts = {}) {
    this.handler.sendNotification('success', message, opts);
  };

  error(message, opts = {}) {
    this.handler.sendNotification('error', message, opts);
  };

  info(message, opts = {}) {
    this.handler.sendNotification('info', message, opts);
  };

  warn(message, opts = {}) {
    this.handler.sendNotification('warning', message, opts);
  };
}

export const notifications = new NotificationHandler();

